<template>
	<div class="changeCourseNameDialog">
		<el-dialog title="修改课堂名称" :close-on-click-modal="false" :visible.sync="dialogVisible" width="500px" >
			<div>
				<el-form ref="form" :model="form" :rules="rules" label-position="top">
					<!-- <el-form-item label="课堂编号" prop="no">
						<el-input v-model="form.no" placeholder="请输入课堂编号,支持英文和数数字结合"></el-input>
					</el-form-item> -->
					<el-form-item label="课堂名称" prop="name">
						<el-input
							v-model="form.name"
							placeholder="请输入课堂名称"
						></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submit('form')">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	emits: ["success"],
	props: {

	},
	data() {
		let validateName = (rule, value, callback) => {
			if (value.trim().length == 0) {
				callback(new Error("请输入课堂名称"));
			} else {
				callback();
			}
		};
		return {
			dialogVisible: false,
			loading:true,
			form: {
				id:"",
				name: "",
				tid:"",
			},
			rules: {
				name: [{ validator: validateName, trigger: "change" }],
			},
		};
	},
	methods: {
		open(item) {
			this.form = {
				id:item.id,
				tid:item.value,
				name: item.label,
			};
			this.dialogVisible = true;
		},
		submit(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.$emit("success", this.form);
					this.dialogVisible = false;
				} else {
					console.log("error submit!!");
					return false;
				}
			});
		},
	},
};
</script>

<style scoped>
.addNewCourse {
}
</style>



// WEBPACK FOOTER //
// src/components/pages/classroomObservation/components/changeCourseNameDialog.vue